import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'

import './plugins/axios'

import router from './router'
import store from './store/store'

Vue.config.productionTip = false

// https://www.iban.com/currency-codes
Vue.filter('currency', value => 
	{
		return value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
	}
)

// Vue.filter('currency', formatNumberAsBRL)
// function formatNumberAsBRL(value) {
// 	if (!value) return ''
//   	return value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
// }

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')

